import { useSport, SPORT_META } from "@/context/SportContext";

export default function SportSwitcher({ sports, sport, onChange, className = "" }) {
  const ctx = useSport();
  const enabled = ctx.enabledSports || ["pickleball"];
  const list = sports || enabled;
  // Hide the switcher entirely when only one sport is available
  if (list.length < 2) return null;

  const value = sport ?? ctx.sport;
  const handle = onChange ?? ctx.setSport;
  return (
    <div className={`inline-flex border border-[#262626] ${className}`} data-testid="sport-switcher">
      {list.map((s) => {
        const m = SPORT_META[s];
        const active = value === s;
        return (
          <button
            key={s}
            type="button"
            onClick={() => handle(s)}
            data-testid={`sport-${s}`}
            className="px-4 py-2 text-xs uppercase tracking-wider transition-colors flex items-center gap-2"
            style={active
              ? { background: m.color, color: "#0A0A0A", fontWeight: 700 }
              : { color: "#A3A3A3" }}
          >
            <span className="w-2 h-2" style={{ background: active ? "#0A0A0A" : m.color }} />
            {m.label}
          </button>
        );
      })}
    </div>
  );
}
